import React from 'react';
import {Divider, Input, InputAdornment, Stack} from '@mui/material';
import {Icon} from '@lightricks/react-design-system';

function MultiLineDropdownTitle({
  label,
  value,
  onChangeSearch,
}: {
  label: string;
  value: string;
  onChangeSearch: (event: React.ChangeEvent<HTMLInputElement>) => void;
}) {
  return (
    <Stack direction="column" spacing={1}>
      <Input
        placeholder={label}
        onChange={onChangeSearch}
        disableUnderline
        value={value}
        startAdornment={
          <InputAdornment position="start">
            <Icon
              appearance="primary"
              name="Actions-Search-Generic"
              size="medium"
            />
          </InputAdornment>
        }
        sx={{
          paddingX: '16px',
        }}
      />
      <Divider />
    </Stack>
  );
}

export default MultiLineDropdownTitle;
